import { type BundleTypeKeys } from '@/store';
import { GridItem } from '../types';
import { ThumbnailPage } from './ThumbnailPage';

export interface DragOverlayContentProps {
  item?: GridItem;
  activeBundleType?: BundleTypeKeys | null;
  selectedIdsLength: number;
}

export const ThumbnailPageOverlay = ({ item, activeBundleType, selectedIdsLength }: DragOverlayContentProps) => {
  if (!item) return null;

  const otherCount = selectedIdsLength - 1;
  const footerText =
    otherCount > 0
      ? `${item.pageIndex + 1} (+${otherCount} other${otherCount > 1 ? "'s" : ''})`
      : `${item.pageIndex + 1}`;

  return (
    <ThumbnailPage
      pageId={item.id}
      pageIndex={item.pageIndex}
      thumbnailUri={item.pageData.thumbnailUri}
      documentName={item.pageData.documentName}
      pageWidth={item.pageData.pageDimensions.width}
      pageHeight={item.pageData.pageDimensions.height}
      isHighRelevance={item.pageData.highRelevance}
      isInLightBundle={item.pageData.inLightBundle}
      isInChronology={Boolean(item.pageData.chronologyEntryIds?.length)}
      activeBundleType={activeBundleType}
      clone={true}
      customFooterText={footerText}
    />
  );
};
